import React from 'react'

import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import ActionIcon from '@components/UI/ActionIcon'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectInfluencerIdentityHasShortlisted } from '@store/influencerIdentities'
import { Container } from '@tribegroup'

const InfluencerIdentityRowPerformanceShortlisted: React.FC = () => {
  const intl = useIntl()
  const campaignId = useCampaignIdFromRoute()
  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const hasShortlist = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityHasShortlisted(state, campaignId, contextInfluencerIdentityId),
  )

  return (
    <Container leftInnerSpacing={1.25} data-testid="influencer-identity-row-shortlisted">
      <ActionIcon
        glyph="heart"
        highlighted={hasShortlist}
        size={1.5}
        tooltip={intl.formatMessage({ id: 'core.text.shortlisted' })}
        noHover
      />
    </Container>
  )
}

export { InfluencerIdentityRowPerformanceShortlisted }
export default InfluencerIdentityRowPerformanceShortlisted
